import { AxiosResponse } from 'axios';

import { BalanceInfo } from './dto/Balance';
import BaseApi from './BaseApi';

const balanceApi = {
  getBalanceInfo(id: number): Promise<AxiosResponse<BalanceInfo>> {
    return BaseApi.get(`api/v1/accounts/balance?accountId=${id}`);
  },
};

export default balanceApi;
